import { getTestBed } from "@angular/core/testing";
import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HelpService } from "../help-service";
import { Router } from "@angular/router";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/internal/operators";
import { getFormApi } from "../dataObject/GetFormApi";

@Component({
  selector: "app-hubungi-kami",
  templateUrl: "./hubungiKami.component.html",
  styleUrls: ["./hubungiKami.component.css"],
})
export class HubungiKamiComponent implements OnInit {
 
  buttonSubmit: boolean;
  buttonLoading: boolean;
  submitted = false;
  zoom : number = 20;
  @ViewChild("msg") msgElement: ElementRef;
  Category: any = ['Product inquiry', 'Order inquiry','Change Email', 'Other']

  // lat=-6.3155467
  // lng=107.094555

  lat=-6.3157999
  lng=107.094680

  constructor(
    public helpService: HelpService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private http: HttpClient
  ) {}

  complaintForm = this.fb.group({
    complaint: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    name: ['', Validators.required],
    phone: ['', [Validators.required, Validators.pattern("^((\\+62-?)|0)?[- +()0-9]+"),
    Validators.minLength(10), Validators.maxLength(15)]],
    category: ['', Validators.required],
    
  });


  private handleError(error: HttpErrorResponse) {
    let errorMessage = "Something bad happened; please try again later.";
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  getFormApi: getFormApi;
  ngOnInit(): void {
    this.buttonSubmit = true;
    this.buttonLoading = false;
  }

  get f() {
    return this.complaintForm.controls;
  }

  submitForm() {

    this.submitted=true;
    console.log(this.complaintForm.value);
    if (this.complaintForm.valid) {
      this.buttonSubmit = false;
      this.buttonLoading = true;

      this.helpService.postComplaint(this.complaintForm.value)
        .subscribe(data => {
          this.getFormApi = data;
          const statusresult = this.getFormApi.status;
          if (this.getFormApi.status === 1) {
            
            this.toastr.success(this.getFormApi.message)
            console.log(this.getFormApi.message);
            alert(this.getFormApi.message)
            this.reloadData();
            
          } else {
            
            this.toastr.error(this.getFormApi.message);
            alert(this.getFormApi.message)
            console.log(this.getFormApi.message);
          }
        }, error => {
          console.log(error)
        });
    } else {
      
      this.validate(this.complaintForm);
      if(this.complaintForm.value.complaint==''
      &&this.complaintForm.value.email!=''
      &&this.complaintForm.value.name!=''
      &&this.complaintForm.value.phone!=''){
        setTimeout(()=>{ // this will make the execution after the above boolean has changed
          this.msgElement.nativeElement.focus();
        },0);  
      }else{
        window.scroll(0,0);
        alert('Lengkapi data')
      }
    }



  }

  validate(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validate(control); //{6}
      }
    });
  }

  reloadData() {
    window.location.reload();
  }

  changeCat(e) {
    console.log(e.value)
    this.category.setValue(e.target.value, {
      onlySelf: true
    })
  }
  get category() {
    return this.complaintForm.get('category');
  }
}

// just an interface for type safety.
interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}
